<div class="rounded border border-secondary">
    <label class="m-2"><i class="fas fa-folder"></i>:{{ path }}</label>
    <button class="btn btn-danger btn-circle btn-sm float-right m-1" matTooltip="Powrót"
        tooltipClass="tooltip-danger" (click)="goBack()">
        <i class="fas fa-arrow-left"></i>
    </button>
</div>
